export const YOUTH_UNEMPLOYMENT = 'youth_unemployment'
export const ALL_UNEMPLOYMENT = 'allpopu_unemployment'
export const YOUTH_EDUCATION = 'youth_education'